// Types
import { SocialInboxMessage } from '@/components/pages/conversations/SocialInbox/types';
import { SocialProfileType } from '@/types/socialProfileType';

// Hooks
import useActiveGroup from '@/utils/hooks/user/useActiveGroup';
import useActiveSocialProfile from '@/utils/hooks/user/useActiveSocialProfile';

export const useFindSPFromMessageId = (props: { message: SocialInboxMessage }) => {
    const { message } = props;

    // Retrieve social profile
    let socialProfile: SocialProfileType | null = null;

    const { activeSocialProfile } = useActiveSocialProfile();
    const { activeGroup } = useActiveGroup();

    if (activeSocialProfile) {
        socialProfile = activeSocialProfile;
    } else if (activeGroup) {
        const socialProfiles = activeGroup?.social_profiles.filter((profiles) => profiles.active);
        socialProfile = socialProfiles?.find((e) => e.id === message?.social_profile_id);
    }

    return {
        socialProfile
    };
};
